import React from "react";
import classNames from 'classnames';
import Risk from '../resources/risk.svg';
import styled from "styled-components";
import Abuse from '../resources/arguing_abuse.png';
import HIVIcon from '../resources/hiv.svg';
import Alcohol from '../resources/alcohol.svg';
import Heart from '../resources/heart.svg';
import {ProgressWrap, WelcomeDiv, ImgDiv, ImgWrap } from './ProgressBar';
// import logo from '../resources/logo.svg';
import logo from '../resources/Vista Logos/logo-transparent-png.png';


const ProgressBar2 = (props) => {
    let sections = [
        {
            title:"alcohol",
            img: Alcohol,
        },
        {
            title:"intercourse",
            img: Heart,
        },
        {
            title:"risk",
            img: Risk,
        },
        {
            title:"abuse",
            img: Abuse,
        },
        {
            title:"hiv",
            img: HIVIcon,
        }
    ];
    const selected = props.selected ? props.selected : "alcohol";
    
        return (
            <ProgressWrap>
               <WelcomeDiv>
                    <ImgDiv>
                        <img src={logo} ></img>
                    </ImgDiv>
                </WelcomeDiv>
                
                <Bar>
                  {sections.map((i, index) => {
                   return( <SectionDiv key={i.title} style={{width: index != sections.length-1 ? "25%" : "fit-content"}}>
                    <ImgWrap className= {classNames({
		'selected': selected === i.title
	})}>
                        <img src={i.img} />
                        </ImgWrap>
                        {index !== sections.length - 1 ?   
                        <Line />  : null
                        }
                    </SectionDiv>)
                  })}
                </Bar>
            </ProgressWrap>
        )
}

const Bar = styled.section`
display: flex;
width: 85%;
justify-content: space-between;
margin: auto;
/* :nth-last-child(){ */
    div:last-child{
        width: fit-content;
        ::after{
        display: none !important;
        }
    }
    @media only screen and (max-width: 700px) {
      width: 95%;
    }
/* } */
`;

// const ImgWrap = styled.section`
// margin-left: -1px;
// z-index: 1;
// margin-top: 5px;
// `;

const SectionDiv = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    width: 25%;
    .selected{
        img{

            width: 100px;
            height: 100px;
            border: 3px solid #025dc7;
            box-shadow: 0px 0px 10px 3px grey;
            border-radius: 50%;
            /* margin-right: 10%; */
            margin-left: -15%;
        }
        @media only screen and (max-width: 700px) {
    /* For everything bigger than 768px */
        img{
            width: 45px;
            height: 45px;
        }
        }
        @media only screen and (min-width: 701px) and (max-width: 1150px) {
    /* For everything bigger than 768px */
        img{
            width: 75px;
            height: 75px;
        }
    }
}
`;
const Line = styled.span`
    height: 10px;
    display: block;
    background-color: white;
    margin-left: -20px;
    margin-right: -5px;
    width: 100%;
    /* padding: -6px; */
    margin-top: -10px;
    @media only screen and (max-width: 700px) {
        /* For everything bigger than 768px */
        height: 4px;
    }
`;

export default ProgressBar2;